import { em } from 'polished'
import styled, { css } from 'styled-components'

const duration = '.12s'
const size = 1.1
const sizePx = 20

export const Wrapper = styled.div`
  display: block;
  position: relative;
  margin: 0 0 ${p => p.theme.indents.inputBottomIndent};
  line-height: 1.25;
  cursor: pointer;

  &:hover .checkbox-box {
    border-color: ${p => p.theme.colors.blackOp5};
  }
`

export const Container = styled.div`
  display: flex;
`

const CheckboxCustomCommon = styled.div.attrs({
  className: 'checkbox-box',
})`
  position: relative;
  display: inline-block;
  // baseLh                         — line height of default text
  // size                           — size of checkbox
  // baseLh - size                  — height of area between checkbox and
  // (baseLh - size) / 4            — half of height of area above checkbox
  top: ${p => (p.theme.typography.baseLh - size) / 4}em;
  width: ${size}em;
  height: ${size}em;
  line-height: ${p => p.theme.typography.baseLh};
  border: ${p => `${em(1)} solid ${p.theme.colors.blackOp3}`};
  border-radius: ${p => p.theme.blocks.blockBorderRadius};
  cursor: pointer;
  transition: border-color ${p => p.theme.animation.timeStandard} ease,
    background-color ${p => p.theme.animation.timeStandard} ease;


  ${({ isCheckInEnd }) =>
    isCheckInEnd
      ? css`
          margin-left: ${em(15)};
        `
      : css`
          margin-right: ${em(15)};
        `}

  ${({ isError }) =>
    isError &&
    css`
      border-color: ${p => p.theme.colors.materialRedOp6};
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      border-color: ${p => p.theme.colors.blackOp2};
    `}
`

export const CheckboxCustomFilled = styled(CheckboxCustomCommon)`
  overflow: hidden;
  box-sizing: border-box;
  width: ${em(sizePx)};
  height: ${em(sizePx)};
  flex-shrink: 0;

  ${p =>
    p.size === 'base' &&
    css`
      top: ${em(5)};
    `}
`

export const IconBox = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  user-select: none;
`

export const CheckboxCustom = styled(CheckboxCustomCommon)`
  &::after,
  &::before {
    content: '';
    position: absolute;
    height: ${em(2)};
    background: ${p => p.theme.colors.lilacDark};
    transition: width ease-in ${duration};
    transform-origin: 0 50%;
    width: 0;
  }

  &::after {
    left: ${em(4)}; // positioning of small part of arrow
    top: ${em(5)}; // positioning of small part of arrow
    transform: rotateZ(42deg);
    transition-delay: ${duration};
  }

  &::before {
    left: ${em(10)}; // positioning of big part of arrow
    top: ${em(11)}; // positioning of big part of arrow
    transform: rotateZ(-54.6deg);
    transition-delay: 0s;
  }
`

export const CheckboxError = styled.span`
  position: absolute;
  top: 100%;
  left: ${p =>
    p.shifted
      ? em(
          30,
          p.size === 'small'
            ? p.theme.typography.textSmallFormsPx
            : p.theme.typography.textSmallDescrPx,
        )
      : '0'};
  width: 100%;
  height: ${p => p.theme.indents.inputBottomIndent};
  font-size: ${p =>
    p.size === 'small'
      ? p.theme.typography.textSmallForms
      : p.theme.typography.textSmallDescr};
  line-height: ${p => p.theme.typography.inputErrorLh};
  color: ${p => p.theme.colors.materialRedOp6};
  overflow: hidden;
`

export const CheckboxInput = styled.input`
  position: absolute;
  visibility: hidden;
  width: 0;
  height: 0;

  &:checked {
    & ~ ${Container} ${CheckboxCustom}, & ~ ${CheckboxCustom} {
      &:after {
        width: ${em(9)};
        transition-delay: 0s;
      }

      &:before {
        width: ${em(27.6)};
        transition-delay: ${duration};
      }
    }

    & ~ ${Container} ${CheckboxCustomFilled}, & ~ ${CheckboxCustomFilled} {
      background: #7645ef;
      border-color: #7645ef;

      ${IconBox} {
        opacity: 1;
      }
    }
  }
`
